module.exports = __webpack_public_path__ + "img/logo-symbol-pandavideo.01197fbf.svg";